import { Routes } from '@angular/router';

export const activitiesRoutes: Routes = [
  {
    path: 'definition',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/admin/activities/definition/overview/overview.component').then(component => component.OverviewComponent),
      },
      {
        path: 'add',
        loadComponent: () => import('@app/admin/activities/definition/add/add.component').then(component => component.AddComponent),
      },
      {
        path: ':activityDefinitionId',
        loadComponent: () => import('@app/admin/activities/definition/details/details.component').then(component => component.DetailsComponent),
      },
      {
        path: ':activityDefinitionId/edit',
        loadComponent: () => import('@app/admin/activities/definition/edit/edit.component').then(component => component.EditComponent),
      },
    ],
  },
  {
    path: 'defect-task-warranty',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/admin/activities/defect-task-warranty/overview/overview.component').then(component => component.OverviewComponent),
      },
      {
        path: 'add',
        loadComponent: () => import('@app/admin/activities/defect-task-warranty/add/add.component').then(component => component.AddComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('@app/admin/activities/defect-task-warranty/details/details.component').then(component => component.DetailsComponent),
      },
    ],
  },
  {
    path: 'fuel',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/admin/activities/fuel/overview/overview.component').then(component => component.OverviewComponent),
      },
      {
        path: 'add',
        loadComponent: () => import('@app/admin/activities/fuel/add/add.component').then(component => component.AddComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('@app/admin/activities/fuel/details/details.component').then(component => component.DetailsComponent),
      },
    ],
  },
  {
    path: 'location',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/admin/activities/location/overview/overview.component').then(component => component.OverviewComponent),
      },
      {
        path: 'add',
        loadComponent: () => import('@app/admin/activities/location/add/add.component').then(component => component.AddComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('@app/admin/activities/location/details/details.component').then(component => component.DetailsComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'definition',
  },
];
